import React, {Fragment } from 'react';
import { 
    FormDataConsumer,
    TextInput 
} from 'react-admin';
import { useForm } from 'react-final-form';
import { makeStyles } from '@material-ui/core/styles';

import Popup from  '../controls/PopupScan'

var formdata = null;
var form = null; 

const useStyles = makeStyles({
    cameraButton: {
        backgroundColor: '#3f51b5',
        "&:hover": {
            backgroundColor: 'navy'
        },
        textAlign: 'center', 
        verticallAign: 'middle',
        borderRadius: '10px',
        color: 'white',
        fontWeight: 'bold',
        float: 'left',
        width: '4em',
       
    }
});

const setValue=(val) => {
    console.log(formdata.control_num)
    if(formdata && formdata.control_num !== undefined && val && val !== '') {
        form.change('control_num', val)
        form.refresh(true)
    }
    //console.log(formdata)
}


const OrderOrigin = ({ formData, ...rest }) => {
    formdata = formData;
    form = useForm();
    const classes = useStyles();

    return (  
        <table >
            <tbody>
                <tr> 
                    <td>
                    <TextInput
                        source="control_num"
                        label=""
                        value = {formData.control_num?formData.control_num : ''}
                        validate={rest.validate? rest.validate: '' } 
                        {...rest}
                    />     
                    </td>
                    <td>
                    <Popup setValue={setValue}  classes={classes}/>  
                    </td>
                </tr>
            </tbody>
        </table>
    );
};
const ControlNum = ({...props}) => (

    <FormDataConsumer>
        {formDataProps => (
            <OrderOrigin {...formDataProps} />
        )}
    </FormDataConsumer>
);

export default ControlNum